import type { PropsWithChildren } from 'react'
import styled from 'styled-components'

export function Wrap({ children }: PropsWithChildren) {
  return <StyledWrap>{children}</StyledWrap>
}

const StyledWrap = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100%;
`
